import { fetchUsersWithProfiles } from "@/lib/manager realtime/userCache";
import { useEffect, useState } from "react";

export const useUsersMap = () => {
    const [namesMap, setNamesMap] = useState<Map<string, string>>(new Map());
    const [emailsMap, setEmailsMap] = useState<Map<string, string>>(new Map());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUsersWithProfiles().then(usersData => {
            const names = new Map<string, string>();
            const emails = new Map<string, string>();
            usersData.forEach(user => {

                names.set(user.id, user.name);
                emails.set(user.id, user.email);
            });
            setNamesMap(names);
            setEmailsMap(emails);
            setLoading(false);
        });
    }, []);

    const getUserName = (id: string) => namesMap.get(id) || 'Usuario desconocido';
    const getUserEmail = (id: string) => emailsMap.get(id) || '';

    return { getUserName, getUserEmail, loading };
};